import { useEffect, useState } from 'react';

interface Props {
  delay?: number;
  enabled?: boolean;
}

interface ReturnProps {
  isScrolling: boolean;
}

const useScrollDetection = ({ delay = 200, enabled = true }: Props): ReturnProps => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    let timeoutId: NodeJS.Timeout;

    const handleScroll = () => {
      setIsScrolling(true);

      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setIsScrolling(false);
      }, delay);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [enabled, delay]);

  return { isScrolling };
};

export default useScrollDetection;
